//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'ProfileRfpList',

    props: {
        requestCart: {

        }
    },

    methods: {

        removeItemFrom(index) {
            this.$store.dispatch("search/removeItem", index);
        },

        openNewTab(url) {
            window.open(url, '_blank')
        },
    },

}

